/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../utils/config';

export const ADD_DEDICATED_CUSTOMER_URL = `${API_URL}/dedicated/dedicated_expiration`;
